import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputRightAddon,
  Select,
  Text,
} from "@chakra-ui/react";
import { faArrowLeft, faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { QtdInput } from "../../components/Qtdinput";
import { useIsAuth } from "../../hooks/useIsAuth";
import { RootState } from "../app/mainReducer";
import { cargasActions } from "./reducer";
import Scan from "../../components/KoderQrCode/KoderQrCodeScanner";

export const Consume: React.FC<{}> = () => {
  useIsAuth();

  const navigate = useNavigate();

  const [codigoPallet, setCodigoPallet] = useState("");
  const [motivo, setMotivo] = useState("");
  const [qtd, setQtd] = useState(0);
  const [isBarcodeScanOpen, setBarcodeScanOpen] = useState(false);
  const dispatch = useDispatch();
  const dadosPallet = useSelector(
    (state: RootState) => state.cargas.dadosPallet
  );
  const error = useSelector((state: RootState) => state.cargas.error);
  const isConsuming = useSelector(
    (state: RootState) => state.cargas.isConsuming
  );
  const consumeMotives = useSelector((state: RootState) => state.cargas?.consumeMotives ?? []);

  const motivoSelecionado = consumeMotives.find((m) => m.ukey == motivo) ?? null;
  const geraProcessamento = motivoSelecionado?.gera_processamento_de_produto == 1;
  const produtoUnidade = dadosPallet?.k21?.produtoUnidade ?? null;
  const qtdPorEmbalagem = dadosPallet?.d04?.quantidade_por_embalagem ?? 1;
  const qtdDestino = qtd * qtdPorEmbalagem;

  useEffect(() => {
    dispatch(cargasActions.clearCheckPallet());
    dispatch(cargasActions.getConsumeMotivesRequest());
    setBarcodeScanOpen(true);
  }, [dispatch]);

  if (isBarcodeScanOpen) {
    return (
      <Flex
        direction="column"
        w="100vw"
        h="100vh"
        overflowX="hidden"
        overflowY="hidden"
      >
        {isBarcodeScanOpen && <Scan setValue={(code: string) => {
          setBarcodeScanOpen(false);
          if (code) {
            setCodigoPallet(code);
            setBarcodeScanOpen(false);
            dispatch(
              cargasActions.requestCheckPallet({
                codigoPallet: code,
                setQtd,
                itens: {},
              })
            );
          }
        }} />}
      </Flex>
    );
  }

  return (
    <Flex
      direction="column"
      w="100vw"
      h="100vh"
      overflowX="hidden"
      overflowY="scroll"
      py="1rem"
      px="0.5rem"
    >
      <Flex direction="row">
        <IconButton
          colorScheme="blue"
          aria-label="Voltar"
          mr="0.4rem"
          onClick={() => navigate(`/`)}
          icon={
            <FontAwesomeIcon
              style={{ marginLeft: "1rem", marginRight: "1rem" }}
              icon={faArrowLeft}
              title="Voltar"
              color="#eee"
            />
          }
        />
      </Flex>
      <Center my="0.5rem">
        <Text fontSize="2xl">Consumir pallet</Text>
      </Center>
      <Center my="0.5rem">
        <Text fontSize="lg">Código do Pallet</Text>
      </Center>

      <Flex my="0.5rem" mx="0.5rem">
        <InputGroup size="md">
          <Input
            value={codigoPallet}
            onChange={(e) => setCodigoPallet(e.target.value)}
            onBlur={() =>
              dispatch(
                cargasActions.requestCheckPallet({
                  codigoPallet,
                  setQtd,
                  itens: {},
                })
              )
            }
            placeholder="Código do pallet"
          />
          <InputRightAddon>
            <IconButton
              aria-label="Ler código com a camera"
              icon={<FontAwesomeIcon icon={faCamera} />}
              onClick={() => setBarcodeScanOpen(true)}
            />
          </InputRightAddon>
        </InputGroup>
      </Flex>
      <Center my="0.5rem">
        <Text fontSize="lg">Motivo</Text>
      </Center>
      <Box my="0.5rem" mx="1rem">
        <Select
          value={motivo}
          onChange={(e) =>
            setMotivo(e.target.value)
          }
          placeholder="Selecione um motivo"
        >
          {consumeMotives.map((item) => (
            <option value={item.ukey} key={item.ukey}>
              {item.descricao}{item.d07_001_c ? ` - (Será enviado para o local ${item.d07_001_c.trim()} - ${item.d07_002_c.trim()})` : ''}
            </option>
          ))}
        </Select>
      </Box>
      {geraProcessamento && dadosPallet && (
        <Box my="0.5rem" mx="0.5rem" borderWidth="1px" borderRadius="md" borderColor="blue.400" p="0.75rem">
          <Text fontWeight="bold" color="blue.600" mb="0.5rem">
            Processamento de produto será gerado
          </Text>
          <Divider mb="0.5rem" />
          <Flex direction="column" gap="0.25rem">
            <Text fontSize="sm">
              <Text as="span" fontWeight="semibold">Saída (fardo): </Text>
              {qtd} {dadosPallet?.d04?.unidade_medida ?? ''} de {dadosPallet?.d04?.codigo} — {dadosPallet?.d04?.descricao}
            </Text>
            {produtoUnidade ? (
              <Text fontSize="sm">
                <Text as="span" fontWeight="semibold">Entrada (unitário): </Text>
                {qtdDestino} {produtoUnidade.unidade_medida ?? ''} de {produtoUnidade.codigo} — {produtoUnidade.descricao}
              </Text>
            ) : (
              <Alert status="warning" py="0.4rem">
                <AlertIcon />
                <AlertDescription fontSize="sm">
                  Produto unitário não configurado no PCP para este produto. Configure antes de prosseguir.
                </AlertDescription>
              </Alert>
            )}
          </Flex>
        </Box>
      )}
      <Center my="0.5rem">
        <Text fontSize="lg">Quantidade Consumida</Text>
      </Center>
      <Center my="0.5rem">
        <QtdInput
          value={qtd}
          total={dadosPallet?.k15.quantidade * 1 - dadosPallet?.k15.consumido * 1}
          onChange={(qtd) => typeof qtd === "number" && setQtd(qtd)}
        />
      </Center>
      {dadosPallet && !dadosPallet?.k15 && !dadosPallet?.j07 && (
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>O Pallet não existe!</AlertTitle>
          <AlertDescription>
            O Pallet {codigoPallet} não existe no banco de dados do sistema!
          </AlertDescription>
        </Alert>
      )}
      {error && (
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>Erro na carga!</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {dadosPallet?.d04?.codigo && (
        <Text>
          Item: {dadosPallet?.d04.codigo} - {dadosPallet.d04.descricao}
        </Text>
      )}
      {motivo === "Picking" && dadosPallet?.d04?.endereco_fisico && (
        <Text>Endereço do pallet: {dadosPallet.d04.endereco_fisico}</Text>
      )}
      <Center>
        <Button
          isLoading={isConsuming}
          disabled={qtd <= 0 || `${codigoPallet}`.trim().length < 3 || (geraProcessamento && !produtoUnidade)}
          onClick={() =>
            dispatch(
              cargasActions.consumeRequest({
                qtd,
                codigoPallet,
                navigate,
                motivo,
              })
            )
          }
          colorScheme="blue"
        >
          Concluir
        </Button>
      </Center>
    </Flex>
  );
};